import { render, staticRenderFns } from "./CloseWindow.vue?vue&type=template&id=d8052846"
import script from "./CloseWindow.vue?vue&type=script&lang=ts"
export * from "./CloseWindow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports